import { getOpenSearchJoubunProperties } from '@/functions/pages/search_joubun';
import path from '../../constants/path';

export const searchJoubun = {
  strict: process.env.NODE_ENV === 'local',
  namespaced: true,
  state: {
    windowName: 'SearchJoubun',
    searchSmallCategoryIdForUserContract: '',
    searchSmallCategoryIdForBestTemplate: '',
    searchSmallCategoryIdForUserTemplate: '',
    searchKeyword: ''
  },
  getters: {
    getSearchSmallCategoryIdForUserContract: state => state.searchSmallCategoryIdForUserContract,
    getSearchSmallCategoryIdForBestTemplate: state => state.searchSmallCategoryIdForBestTemplate,
    getSearchSmallCategoryIdForUserTemplate: state => state.searchSmallCategoryIdForUserTemplate
  },
  mutations: {
    setSearchSmallCategoryIdForUserContract(state, payload) {
      state.searchSmallCategoryIdForUserContract = payload;
      localStorage.setItem('searchSmallCategoryIdForUserContract', payload);
    },
    setSearchSmallCategoryIdForBestTemplate(state, payload) {
      state.searchSmallCategoryIdForBestTemplate = payload;
      localStorage.setItem('searchSmallCategoryIdForBestTemplate', payload);
    },
    setSearchSmallCategoryIdForUserTemplate(state, payload) {
      state.searchSmallCategoryIdForUserTemplate = payload;
      localStorage.setItem('searchSmallCategoryIdForUserTemplate', payload);
    },
    init(state, payload) {
      state.searchSmallCategoryIdForUserContract = localStorage.getItem('searchSmallCategoryIdForUserContract');
      state.searchSmallCategoryIdForBestTemplate = localStorage.getItem('searchSmallCategoryIdForBestTemplate');
      state.searchSmallCategoryIdForUserTemplate = localStorage.getItem('searchSmallCategoryIdForUserTemplate');
      localStorage.setItem('searchKeyword', payload.searchKeyword);
    }
  },
  actions: {
    setSearchSmallCategoryIdForUserContract({ commit }, payload) {
      commit('setSearchSmallCategoryIdForUserContract', payload);
    },
    setSearchSmallCategoryIdForBestTemplate({ commit }, payload) {
      commit('setSearchSmallCategoryIdForBestTemplate', payload);
    },
    setSearchSmallCategoryIdForUserTemplate({ commit }, payload) {
      commit('setSearchSmallCategoryIdForUserTemplate', payload);
    },
    openWindow({ state, commit }, searchKeyword) {
      commit('init', { searchKeyword: searchKeyword });
      window.open(window.location.origin + path.searchJoubun, state.windowName, getOpenSearchJoubunProperties());
    },
    destroy({ state }) {
      setTimeout(() => {
        window.open('', state.windowName, true).close();
      }, 1);
      localStorage.removeItem('searchKeyword');
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/search_joubun.js